import { useAtomValue } from '@/utils/jotai-svelte';
import { onMountWithActiveText, teoActiveTextAtom } from '@/utils/teo-context';

export const CurrentText$ = teoActiveTextAtom((activeText) => activeText.text);
CurrentText$.onMount = onMountWithActiveText(({ refresh }, text) => {
  refresh();
  return text.events.addEventListener('textChanged', refresh);
});

export const useCurrentText = () => useAtomValue(CurrentText$);
